import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { RootState } from "../../app/store";
import { resolveFormula } from "./resolveFormula";

/**
 * 現在のルートパス（または指定パス）に対応する「サイドメニュー」の名前を返す。
 *
 * - URL に一致するメニューが見つからなかったら空文字
 * - 一致したメニューが tab / subitem の場合は親メニュー（sidebar_top / sidebar_bottom）の名前を返す
 * - 一致したメニューが親メニュー（parent_id IS NULL）ならその名前をそのまま返す
 *
 * これにより、タブを切り替えてもページタイトルが常にサイドメニュー名と一致する。
 */
export function useMenuTitle(path?: string): string {
    const { t } = useTranslation("common");
    const location = useLocation();
    const targetPath = path ?? location.pathname;
    const menus = useSelector((state: RootState) => state.menu.items);
    const menu = menus.find((m) => m.url === targetPath);
    if (!menu) return "";

    // tab / subitem の場合は親メニューの名前を返す
    const titleMenu =
        menu.parent_id != null
            ? (menus.find((m) => m.id === menu.parent_id) ?? menu)
            : menu;
    return resolveFormula(titleMenu.name_formula, t, titleMenu.name);
}
